export const getAllFromTokenEndpoint = async <T>(
  func: (after: string | null) => Promise<WithTokenPagination<T[]>>
) => {
  const allData: T[] = []

  // Make requests until the returned next token is null
  let after = null
  do {
    const { data, pagination } = await func(after)
    allData.push(...data)
    after = pagination.next
  } while (after !== null)

  return allData
}
